/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import {
  CustomerDTO,
  PositionDTO,
  QuotationDTO,
  ObligationDTO
} from '@api/models/';
import { DtoManager } from '../generic';

export class Position extends DtoManager<PositionDTO> {
  constructor(dto: PositionDTO) {
    super(dto);
  }

  checkIntegrity(): void {
    if (!this.data || !this.data.positionId) {
      throw new Error(`Position data is malformed`);
    }
  }

  getQuotation(): QuotationDTO {
    return (this.data && this.data.product) || undefined;
  }

  getObligations(): ObligationDTO[] {
    return (this.data && this.data.obbligationDtoList) || [];
  }

  getCustomer(): CustomerDTO {
    return (this.data && this.data.customer) || undefined;
  }

  getCustomerNdgType(): string {
    const customer = this.getCustomer();
    return (customer && customer.ndgType) || null;
  }

  getCustomerName(): string {
    const customer = this.getCustomer();
    return (customer && customer.firstName) || null;
  }

  // pensionato altri enti
  isRetired(): boolean {
    return this.getCustomerNdgType() === 'P';
  }

  // pensionato inps
  isRetiredINPS(): boolean {
    return this.getCustomerNdgType() === 'I';
  }

  // dipendente
  isEmployee(): boolean {
    return this.getCustomerNdgType() === 'D';
  }

  // dipendente mef
  isEmployeeMEF(): boolean {
    return this.getCustomerNdgType() === 'M';
  }
}
